import React from "react";

const LeftCarretIcon = ({width=20,height=20}) => {
  return (
    <svg width={width} height={height}  cursor="pointer" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.125 3.75L6.875 10L13.125 16.25" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>      
  );
};

export default LeftCarretIcon;
